import { languages } from "../languages"

const location = "New-Brunswick";
const locale = "en-CA";

const contactInfo = {
  "contact-info.telephone-number": "1-506-501-2241",
  "contact-info.email": "edmundston@andmar.ca",
}

const customData = {
  "PresentationImage":"MainPagePresentation",
}

export const main =
{
  locale: "en-CA",
  prefix: "main",
  slugs: {},
  messages: {
    ...languages[locale.slice(0,2)](location).messages,
    ...contactInfo,
    cityPresentationImage:"../images/GirlHeatPumpImage.jpg",
    test1:"test", ...customData}
}